import { createColumnHelper } from '@tanstack/react-table';
import { TableLink } from '@monorepo/base/src/components/table/table-link/table-link';
import { BetweenPagesStateProps } from '@monorepo/tools/src/lib/interfaces/global';
import routes from '../../routes/index.routes';
import { IMergedHeadersReturn } from './index.headers';
import { IAdminxStore } from '../../stores';
import { useStores } from '@monorepo/controlled/src/hooks/use-stores';
import { useRoute } from '@monorepo/tools/src/lib/hooks/tools/use-route';
import { useEffect } from 'react';
import { DestinationModel } from '../../models/destination.model';

const columnHelper = createColumnHelper<DestinationModel>();

export const useDestinationHeaders = (): IMergedHeadersReturn<DestinationModel> => {
	const { settingsStore } = useStores<IAdminxStore>();
	const { currentRouteWithoutSpecialChars } = useRoute();
	const tableStore = settingsStore.pages.get(currentRouteWithoutSpecialChars)?.tableStore;

	useEffect(() => {
		if (tableStore && Object.keys(tableStore.getColumnVisibility()).length === 0) {
			tableStore.setDefaultColumnVisibility({
				id: true,
				name: true,
				advertiser: true,
				account: true,
				yid: true,
				dest_url: true,
			});
			tableStore?.setColumnVisibility(tableStore.getDefaultColumnVisibility());
		}
	}, [tableStore]);

	return {
		columns: [
			columnHelper.accessor('id', {
				header: 'ID',
				cell: ({ row }) => row.original.getId(),
			}),
			columnHelper.accessor('name', {
				header: 'Name',
				cell: info => {
					const destination = info.row.original;
					return (
						<TableLink
							toEdit={routes.destinations.edit(String(destination.getId()))}
							toEditState={{ isBlockRequest: true } as BetweenPagesStateProps}>
							{destination.getName() || destination.getId()}
						</TableLink>
					);
				},
			}),
			columnHelper.display({
				id: 'advertiser',
				header: 'Advertiser',
				cell: ({ row }) => row.original.getAdvertiser()?.getName() ?? '',
			}),
			columnHelper.display({
				id: 'account',
				header: 'Account',
				cell: ({ row }) => row.original.getAccount()?.getName() ?? '',
			}),
			columnHelper.accessor('yid', {
				header: 'Product ID',
				cell: ({ row }) => row.original.getYid() ?? '',
			}),
			columnHelper.accessor('dest_url', {
				header: 'Destination URL',
				cell: ({ row }) => row.original.getDestUrl() ?? '',
			}),
		],
	};
};
